import { render, staticRenderFns } from "./PopupReg.vue?vue&type=template&id=29b9820d&scoped=true"
import script from "./PopupReg.vue?vue&type=script&lang=js"
export * from "./PopupReg.vue?vue&type=script&lang=js"
import style0 from "./PopupReg.vue?vue&type=style&index=0&id=29b9820d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9820d",
  null
  
)

export default component.exports